import {useState, useEffect} from 'react';
import {ReactComponent as ProfilePicture} from '@Assets/blankProfile.svg';
import { IoClose as Close } from 'react-icons/io5';
import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';
import Avatar from '@mui/material/Avatar';
import UserInfoService from '@Helpers/URLHelpers/UserInfoService';
import ErrorHandler from '@Root/ErrorHandler';
import './ProfileBanner.scss';

export default function ProfileBanner(props) {

    const [photo, setPhoto] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [uploadStatus, setUploadStatus] = useState('');
    const [user, setUser] = useState({});
    const [organizations, setOrganizations] = useState([]);
    const userInfoService = new UserInfoService();
    const errorHandler = new ErrorHandler();
    const activeUserId = localStorage.getItem('activeUserId');
    const currentOrg = localStorage.getItem('currentOrg');
    const currentOrgId = localStorage.getItem('currentOrgId');
    let currentUserOrgPermissions = JSON.parse(localStorage.activeUserPermissions).orgs[currentOrgId];
    const colorList = ['#2784B9', '#40c47d', '#FDB16C', '#b06060', '#f77474', '#6080b0', '#9a60b0', '#6cb060',
        '#b0ae60', '#65412b', '#cc9963', '#e1bd83', '#60748b', '#744700', '#c8d579', '#5f8fba', '#3e6073', '#8e6dc1', '#473785',
       '#9158a9',  '#7f3f7a', '#583e84', '#073763', '#20124d', '#3d124d', '#64113f', '#780448', '#003e23', '#108764', '#1a4c3d',
        '#c8d77f', '#11888b', '#1a95bd', '#0d6c7b', '#25b56e', '#006e3d'];
    const className = 'profileBanner';

    useEffect(() => {
        if (props.profileId) {
            renderData();
        }
    }, [])

    const renderData = async () => {
        try {
            await renderUserData();
        } catch (err) {
            errorHandler.handleError(err);
        }
    }

    const getInitials = (string) => {
        if(!!string && string.length > 0) {
            var names = string?.split(' '),
                initials = names[0]?.substring(0, 1)?.toUpperCase();

            if (names?.length > 1) {
                initials += names[names?.length - 1]?.substring(0, 1)?.toUpperCase();
            } else {
                names = string?.split('@');
                initials = names[0]?.substring(0, 1)?.toUpperCase();

                if (names?.length > 1) {
                    initials += names[names?.length - 1]?.substring(0, 1)?.toUpperCase();
                }
            }
            return initials;
        }
        return 'N/A';
    };

    const renderUserData = async() => {
        var loadLoops = 0, loadingError = false, errorException;
        for(loadLoops = 0; loadLoops < 10; loadLoops++) {
            try {
                let userObj = await userInfoService.getUserById(props.profileId);
                userObj = JSON.parse(userObj.body);
                setUser(userObj);
                setPhoto( !userObj.photo || userObj.photo === 'null' ? '' : userObj.photo);
                setImageUrl( !userObj.photo || userObj.photo === 'null' ? '' : userObj.photo );
                loadingError = false;
                break;
            } catch (err) {
                errorHandler.logError('User Data', err);
                loadingError = true;
                errorException = err;
            }
        }
        if(loadLoops === 10 && loadingError === true) {
            errorHandler.handleError(errorException);
            return false;
        }
        return true;
    }

    const dataURLtoFile = (dataurl) => {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], {type: mime});
    }

    return (
        <div>
            <div className={className}>
                <div className={className + '__inner flex-column-center gap-1rem'}>
                    <div className = {className + '__inner__photo'}>
                        {
                            (!!photo && photo !== '') ? (
                                <>
                                    <Avatar
                                        src={photo}
                                        sx={{ width: 100, height: 100 }}
                                    />
                                </>
                            ) : (
                            <>
                                <Avatar
                                    sx={{ bgcolor: colorList[user?.fullName?.charCodeAt(0) % colorList?.length] + ' !important',
                                    width: 90, height: 90,}}>
                                    {getInitials(user?.fullName)}
                                </Avatar>
                            </>
                        )}
                    </div>
                    <div className={className + '__inner__info flex-column-center gap-0p5rem'}>
                        <div className={className + '__inner__info__name flex-column-center gap-0p5rem'}>
                            <div className={className + '__inner__info__name__fullName semi-bold-text large-text'}>{user?.fullName}</div>
                            <div className={className + '__inner__info__name__userName blue-text'}>@{user?.userName}</div>
                        </div>
                        <div className={className + '__inner__info__role'}>{user?.designation}</div>
                        <div className={className + '__inner__info__email'}>{user?.email}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}